import * as React from "react"

import "./Report.scss"

interface Props {
    action: Contracts.Action
}

export const ReportAction = ({ action }: Props): JSX.Element => (
    <li>
        {action.actionType !== "None" && action.actionType} {action.type}&nbsp;
        <em>{action.code}</em>
        <ul>
            {(action.changes ?? []).map((change, idx) => (
                <li key={`change-${idx}`}>
                    {change.property}: {change.before} &rarr; {change.after}
                </li>
            ))}
        </ul>
        <ul>
            {(action.actions ?? []).map((childAction, idx) => (
                <ReportAction key={`action-${idx}`} action={childAction} />
            ))}
        </ul>
    </li>
)

export default ReportAction
